import React from 'react'
import classNames from 'classnames'
import { InfoButton } from 'components/buttons'

const FavoriteFilters = ({ addFilter, className, label, selected }) => (
  <React.Fragment>
    {label && (
      <React.Fragment>
        <hr className="mbl" />
        <div className="h6 text-uppercase text-bold text-light tiny mtn mbs">
          {label}
        </div>
      </React.Fragment>
    )}

    <InfoButton
      className={classNames(className)}
      empty={!selected}
      onClick={() => addFilter({ favoritesView: !selected })}
      pill
      size="small"
      selected={!!selected}
    >
      Must Have
    </InfoButton>
  </React.Fragment>
)

export default FavoriteFilters
